import { FeeLevel, GasFeeInfo, CommonWalletInfo } from './common';
import { AccountOneInfo, ShowType } from './account';

export type PostUnstakeFeeParams = {
  chainCode?: string;
  poolCode?: string;
  poolType?: string;
  poolId: number;
  lpTokens: string;
  slippage: string;
  isSingle: boolean;
  withdrawAddresses: Array<{ contractAddress: string }>;
  level: FeeLevel;
  minOutAmount?: string;
  unstakeType?: ShowType;
};

export type PostUnstakeFeeRes = {
  gas: GasFeeInfo;
};

export type PostUnstakeParams = {
  poolId: number;
  chainCode: string;
  poolCode: string;
  lpTokens: string;
  slippage: string;
  poolType: string;
  withdrawAddresses: { contractAddress: string }[];
  estimateFee: number[];
  gasLimit: number;
  priority: number;
  baseFee: number;
  gasMax: number;
  maxPriorityFeePerGas: number;
  minOutAmount?: string;
  router?: string;
  //1表示延迟赎回;
  unstakeType?: ShowType;
};

export type PostUnstakeEncodeParams = CommonWalletInfo & {
  lpTokens: string;
  poolId: number;
  slippage?: string;
  unstakeTokens: string[];
  minOutAmount?: string;
  router?: string;
  // 1为延迟赎回；0为正常赎回
  unstakeType?: ShowType;
  lombardReceiver?: {
    btcAddress: string;
    chainId: number;
    chainCode: string;
  };
};

export enum UnstakeEncodeStage {
  ApproveAmount = 21,
  ApproveTrade = 29,
  UnKnow = 0,
}

export type BroadcastData = {
  from: string;
  to: string;
  value: string;
  data: string;
  hash: string;
};

export type PostUnstakeEncodeRes = {
  orderCode: string;
  stage: UnstakeEncodeStage;
  broadcastData?: BroadcastData[];
  txDataList: Array<{
    data: `0x${string}`;
    from: string;
    gasLimit: string;
    to: `0x${string}`;
    value: string;
    gasFee: string;
    gasPrice?: string;
  }>;
};

export type PostSaveUnstakeOrderParam = PostUnstakeEncodeParams & {
  stage: UnstakeEncodeStage;
  // 是否广播 null，0-不广播 1-广播
  broadcast?: number;
  broadcastData?: {
    signData: string;
    chainId: number;
    from: string;
    to: string;
    value: string;
    txHash: string;
  }[];
  orderCode?: string;
  walletId?: string;
  walletType?: number;
  unstakeType?: ShowType;
  lombardReceiver?: {
    btcAddress: string;
    chainId: number;
    chainCode: string;
  };
};

export type PostSaveUnstakeOrderRes = {
  orderCode: string;
  orderTxId: number;
};

export type GetUnstakeAmountParamsV2 = {
  poolId: number;
  poolCode: string;
  poolType: string;
  lpAmount: string;
  // 0双币 1单币
  type: number;
  /**
   * token合约地址，用,分割
   */
  contractAddresses: string;
};

export type GetUnstakeAmountResV2 = {
  scaleList: [
    {
      amount: string;
      contractAddress: string;
    },
  ];
};

export type GetUnstakeEstimateTokenParam = CommonWalletInfo & {
  poolId: number;
  lpTokens: string;
  // 0双币 1单币
  type: UnstakeType;
  /**
   * token合约地址，用,分割
   */
  unstakeTokens: string[];
  slippage: string;
  //1表示延迟赎回
  unstakeType?: ShowType;
};

export interface DelayRedeemInfo {
  currentEpoch: number;
  currentEpochRemain: number;
  finalTime: number;
}

export type GetUnstakeEstimateTokenRes = {
  tokenAmounts: Array<{
    amount: string;
    contractAddress: string;
    slippage: string;
    router?: string;
    isLoss?: boolean;
  }>;
  delayInfo: DelayRedeemInfo;
};

export type GasStore = {
  level: FeeLevel;
  amount: string;
  price: string;
  estimateFee: string;
  priority: string;
  max: string;
  symbol: string;
  limit: string;
  gasPrice: string;
  isLoading: boolean;
  hasGasFee: boolean;
  loopPercent: number;
};

export type UnStakeOption = {
  accountInfo: AccountOneInfo;
  unstakeType: UnstakeType;
  slippage: string;
  supportWallets: number[];
  unstakeAmount: string;
  slippageIsLost: boolean;
  unstakeStage: UnstakeEncodeStage;
  selectCoinList: string[];
  process: Process;
  gasStore: GasStore;
  confirmButtonIsLoading: boolean;
  unstakeCoinAmountStore: UnstakeCoinInfoStore;
  isSolLoss?: boolean;
  showType?: ShowType;
  extraCoinInfo?: ExtraCoinInfo;
  onChangeUnstakeStage: (v: UnstakeEncodeStage) => void;
  onChangeButtonLoading: (v: boolean) => void;
  onChangeUnstakeAmount: (v: string) => void;
  onChangeProcess: (v: Process) => void;
  onClose: () => void;
  onSuccess: () => void;
  onChangeShowType: (v: ShowType) => void;
};

export enum UnstakeType {
  Multiple = '0',
  Single = '1',
}

export type UnstakeMethodTypeConfig = {
  key: string;
  value: string;
  childrenNode: string;
};

export enum Process {
  None,
  Confirm,
  Result,
  Delay,
  Slippage,
  SolLoss,
}

export type UnstakeCoinInfoStore = Record<
  string,
  {
    amount: string;
    slippage: string;
    router?: string;
    isLoss?: boolean;
  }
>;

export interface ExtraCoinInfo {
  btcAddress: string;
  chainId: number;
  chainCode: string;
}

export interface PostCancelEncodeParam {
  poolId: number;
  walletAddress: string;
  chainId: number;
}

export interface SaveCancelOrderParam {
  poolId: number;
  walletAddress: string;
  chainId: number;
  broadcastData: BroadcastData[];
}
